export enum FeedImportType {
    RSS
}
